export default "__VITE_ASSET__CEqdDLBW__"